// extracted by mini-css-extract-plugin
export default {"mainBox":"Layout_mainBox__QGABZ","sidebarDesktop":"Layout_sidebarDesktop__YMQZr","subMainBox":"Layout_subMainBox__vccYy","contentBox":"Layout_contentBox__iSHJs"};